import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../styles/About.scss";

import { ReactComponent as TeamSvg } from "../svgs/team.svg";
gsap.registerPlugin(ScrollTrigger);
function About() {
  const divRef = useRef(null);
  useEffect(() => {
    const div = divRef.current.children;
    gsap.fromTo(
      div,
      { y: "+=300", autoAlpha: 0 },
      {
        duration: 0.5,
        y: "-=300",
        autoAlpha: 1,
        ease: "none",
        scrollTrigger: {
          id: "about",
          trigger: div,
          start: "top bottom",
        },
      }
    );
  }, []);
  return (
    <div className="aboutContainer" id="about" ref={divRef}>
      <div className="aboutLeftSide">
        <TeamSvg className="teamSvg" />
      </div>
      <div className="aboutRightSide">
        <h3>About Us</h3>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras
          facilisis eu eros eu malesuada. Integer ac mattis purus. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit. Cras facilisis eu eros eu
          malesuada. Integer ac mattis purus.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras
          facilisis eu eros eu malesuada. Integer ac mattis purus. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit. Cras facilisis eu eros eu
          malesuada. Integer ac mattis purus.
        </p>
      </div>
    </div>
  );
}

export default About;
